export type ViewMode = "quarterly" | "annual";

export interface PeriodOption {
  label: string;
  value: number;
}

export const QUARTERLY_PERIOD_OPTIONS: PeriodOption[] = [
  { label: "4 Quarters", value: 4 },
  { label: "8 Quarters", value: 8 },
  { label: "12 Quarters", value: 12 },
  { label: "16 Quarters", value: 16 },
  { label: "20 Quarters", value: 20 },
  { label: "24 Quarters", value: 24 },
  { label: "40 Quarters", value: 40 },
];

export const ANNUAL_PERIOD_OPTIONS: PeriodOption[] = [
  { label: "3 Years", value: 3 },
  { label: "4 Years", value: 4 },
  { label: "5 Years", value: 5 },
  { label: "8 Years", value: 8 },
  { label: "10 Years", value: 10 },
  { label: "12 Years", value: 12 },
  { label: "15 Years", value: 15 },
  { label: "20 Years", value: 20 },
  { label: "25 Years", value: 25 },
];

export const DEFAULT_QUARTERLY_LIMIT = 12;
export const DEFAULT_ANNUAL_LIMIT = 10;

export const MAX_QUARTERLY_LIMIT = 40;
export const MAX_ANNUAL_LIMIT = 25;

export const safeSlice = <T>(arr: T[], limit: number): T[] => {
  if (!arr || arr.length === 0) return [];
  return arr.slice(-limit);
};

export const getApiPeriodParam = (
  viewMode: ViewMode
): "annual" | "quarter" => {
  return viewMode === "quarterly" ? "quarter" : "annual";
};
